<template>
  <div class="wizard-step-content wizard-step-centering">
    <ul class="wizard-step-content__group-list u-reset">
      <li
        v-if="mapConfig.projectionId !== $options.projectionIds.ORTHOGRAPHIC"
        class="wizard-step-content__group"
      >
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.centering.move_center_title') }}
        </h2>

        <div class="wizard-step-centering__map-wrap">
          <world-map
            v-bind="rotationMapConfig"
            :allow-rotation="true"
            :allow-zoom="false"
            :facets="[]"
            :map-padding="[4, 4, 4, 4]"
            class="wizard-step-centering__map"
          />
        </div>
      </li>
      <li class="wizard-step-content__group">
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.centering.shift_center_title') }}
        </h2>

        <center-shifter :rotation="rotationMapConfig.rotation" @update="onUpdate" />
      </li>
      <li class="wizard-step-content__group">
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.centering.set_center_title') }}
        </h2>

        <client-only>
          <location-search :rotation="rotationMapConfig.rotation" @update="onUpdate" />
        </client-only>
      </li>
      <li class="wizard-step-content__group">
        <h2 class="u-reset wizard-step-content__sub-title">
          {{ $t('wizard_step.centering.current_center_title') }}
        </h2>

        <client-only>
          <location-requester :rotation="rotationMapConfig.rotation" @update="onUpdate" />
        </client-only>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { isEqual, throttle } from 'lodash-es'
  import WorldMap from '@/components/world-map/world-map'
  import { mapConfigIds } from '@/assets/js/model/map-config'
  import CenterShifter from '@/components/center-shifter/center-shifter'
  import LocationSearch from '@/components/location-search/location-search'
  import LocationRequester from '@/components/location-requester/location-requester'
  import { THROTTLE_INTERVAL } from '@/components/world-map-viewer/util'
  import { projectionIds } from '@/assets/js/model/projection'

  const { CUSTOM_WIZARD, WIZARD_STEP_CENTERING } = mapConfigIds

  export default {
    components: { LocationRequester, LocationSearch, CenterShifter, WorldMap },
    props: {
      mapConfig: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('world-map', ['mapConfigs']),
      rotationMapConfig() {
        return this.mapConfigs[WIZARD_STEP_CENTERING]
      },
    },
    watch: {
      'mapConfig.rotation'(newValue, oldValue) {
        if (isEqual(newValue, oldValue)) {
          return
        }

        this.throttledSetRotation(WIZARD_STEP_CENTERING, this.mapConfig.rotation)
      },
      'rotationMapConfig.rotation'(newValue, oldValue) {
        if (isEqual(newValue, oldValue)) {
          return
        }

        this.throttledSetRotation(CUSTOM_WIZARD, this.rotationMapConfig.rotation)
      },
    },
    created() {
      this.updateMapConfig({
        rotation: this.mapConfig.rotation,
        id: WIZARD_STEP_CENTERING,
      })
    },
    methods: {
      ...mapActions('world-map', ['updateMapConfig']),
      onUpdate(rotation) {
        this.throttledSetRotation(WIZARD_STEP_CENTERING, rotation)
      },
      setRotation(id, rotation) {
        this.updateMapConfig({ id, rotation })
      },
      throttledSetRotation: throttle(function (id, rotation) {
        this.setRotation(id, rotation)
      }, THROTTLE_INTERVAL),
    },
    projectionIds,
  }
</script>

<style lang="scss" src="./_wizard-step-centering.scss" />
